/**
 * Name matching for suggestions (APP-566 Meta access): the same algorithm the
 * API uses to rank Instagram accounts against a company name
 * (`InstagramInsightsConnectorService.resolveCustomConnectorConfigOptions`).
 */

/** Lower case, letters and digits only: "Acme Corp." and "@acme_corp" both become "acmecorp". */
export function slug(value: string | null | undefined): string {
  return (value ?? "").toLowerCase().replace(/[^a-z0-9]/g, "")
}

/**
 * Sørensen–Dice on character bigrams, 0..1. Cheap and dependency-free; handles
 * "hexclad" / "@hexclad" and "Acme Corp" / "acmecorp" pairs well (slug first).
 */
export function diceSimilarity(a: string, b: string): number {
  if (!a || !b) return 0
  if (a === b) return 1
  if (a.length < 2 || b.length < 2) return 0
  const bigrams = new Map<string, number>()
  for (let i = 0; i < a.length - 1; i++) {
    const bigram = a.slice(i, i + 2)
    bigrams.set(bigram, (bigrams.get(bigram) ?? 0) + 1)
  }
  let overlap = 0
  for (let i = 0; i < b.length - 1; i++) {
    const bigram = b.slice(i, i + 2)
    const count = bigrams.get(bigram) ?? 0
    if (count > 0) {
      overlap += 1
      bigrams.set(bigram, count - 1)
    }
  }
  return (2 * overlap) / (a.length + b.length - 2)
}
